import { makeStyles } from '@material-ui/core';
import Colors from '../Colors';

export const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    boxSizing: 'border-box',
  },
  mainItemWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "0.5rem",
    gap: "0.25rem",
  },
  mainItemTitleHeader: {
    width: "100%",
    padding: "0.375rem 1.125rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: Colors.main,
    color: "#ffffff",
    fontSize: "1rem",
    fontWeight: "bold",
  },

  mainItemInfoWrapper: {
    width: "100%",

    padding: "0.5rem 5rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  subItemWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  subItemHeader: {
    width: "100%",
    padding: "0.5rem 1.25rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    backgroundColor: Colors.secundary,
    textTransform: 'uppercase',
    fontSize: "0.75rem",
    gap: "0.5rem",
  },

  mapView: {
    margin: "0.5rem 0",
    padding:"0 0 0.5rem 0 ",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "0.5rem",
    width: "100%",
    height: "15rem",
    border: "1px solid #000000"
  },
  map: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    border: "1px solid #000000"
  },
  leafletContainer: {
    width: "100%",
    height: "100%",
  },
  mapSubtitles: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
    gap: "4rem",
  },
  subItemInfo: {
    width: "100%",
    padding: " 0.5rem 2.5rem",
    display: "grid",
    gridTemplateColumns: "auto auto",
    justifyItems: "start",
    alignItems: "center",
    justifyContent: "space-between",
    gap:"0.5rem", 
  },
  obsBox: {
    minHeight: "5.625rem",
    width: "100%",
    padding: "1rem 1.25rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "0.625rem",
    backgroundColor: Colors.secundary_translucent,
    fontSize: "0.625rem",
  },
  damageFormTableWrapper: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  damageFormHeader: {
    padding:"0.5rem; 0",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: Colors.secundary,
    textTransform: "uppercase",
    fontSize: "0.625rem",
    gap: "0.5rem",
  },

  damageFormTableContent: {
    fontFamily: "arial, sans-serif",
    width: "100%",
    padding: " 0.5rem 0.5rem",
    display: "grid",
    gridTemplateColumns: "50% 50%",
    justifyItems: "start",
    alignItems: "stretch",
    justifyContent: "space-evenly",
  },
  damageTableGroup: {
    width: "100%",
    padding: "0 0.5rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
  },

  itemInfoValue: {
    display: "flex",
    fontFamily: "arial, Helvetica, sans-serif",
    textTransform: "uppercase",
    fontSize: "0.625rem",
  },
  subItemWrapperAgents: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "1rem",
  },
  subItemWrapperAgentsSubItem: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    flexWrap: "nowrap",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap:"0.5rem",
  },
  subItemInfoAgents: {
    padding: "0 0.5rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap:"0.5rem",
  },
}))



